import { ref, computed, onBeforeUnmount, nextTick } from 'vue'
import useViewport from '../features/viewport.js'

export const useSlider = () => {
  const { desktop, tablet, mobile } = useViewport()
  const currentIndex = ref(0)
  const timer = ref(0)
  const duration = ref(3000)
  const ticking = ref(0)
  const tickingTimer = ref(null)
  const imageProperty = ref('thumb')
  const activeSlide = ref({})
  const slides = ref([])
  const heroYouTubePlayer = ref(null)
  const playingState = ref(true)
  const videoPercent = ref(0)

  const getCurrentImage = computed(() => {
    if (slides.value.length) {
      return slides.value[currentIndex.value][imageProperty.value]
    }
    return ''
  })
  const thumbnailTimer = computed(() => {
    if (
      currentSlideBackgroundVide.value &&
      activeSlide.value.vid &&
      desktop.value
    ) {
      return videoPercent.value
    }
    return getTimer.value
  })
  const getSlides = computed(() => {
    return slides.value
  })

  const movieCurrentSlide = computed(() => {
    return activeSlide.value.movieSlide
  })

  const currentSlideBackgroundVide = computed(() => {
    return activeSlide.value.vid
  })

  const getTimer = computed(() => {
    return (100 / (duration.value / 1000)) * ticking.value
  })

  const playingControlBtn = computed(() => {
    return playingState.value
      ? 's-hero-slider__pause-btn'
      : 's-hero-slider__play-btn'
  })

  const startSlider = (slideDuration = 3000) => {
    stopTimerTicking()
    duration.value = slideDuration
    if (!currentSlideBackgroundVide.value || !desktop.value) {
      // image slide case
      startImageSlide(slideDuration)
    } else if (desktop.value && activeSlide.value.vid) {
      // youtube slide case
      startYoutubeVideoSlide()
    }
  }
  const startYoutubeVideoSlide = async () => {
    videoPercent.value = 0
    await nextTick()
    if (heroYouTubePlayer.value) {
      // heroYouTubePlayer.value.loadVideoById(activeSlide.value.vid)
      playingState.value = true
    }
  }
  const startImageSlide = (slideDuration) => {
    timer.value = setInterval(() => {
      nextSlide()
    }, slideDuration)
    startTickingTimer()
  }
  const startTickingTimer = () => {
    tickingTimer.value = setInterval(() => {
      ticking.value = ticking.value + 1
    }, 1000)
  }

  const nextSlide = async () => {
    pauseCurrentVideo()
    if (currentIndex.value < slides.value.length - 1) {
      currentIndex.value = currentIndex.value + 1
    } else {
      currentIndex.value = 0
    }
    setActiveSlide()
    await nextTick()
    startSlider(duration.value)
  }

  const stopTimerTicking = () => {
    timer.value && clearInterval(timer.value)
    tickingTimer.value && clearInterval(tickingTimer.value)
    ticking.value = 0
  }

  const setSlides = (data, imageProp) => {
    if (data.length) {
      slides.value = data
      imageProperty.value = imageProp
      activeSlide.value = data[0]
    }
  }

  const chooseSlide = (slideIndex) => {
    currentIndex.value = slideIndex
    setActiveSlide()
    startSlider(duration.value)
  }

  onBeforeUnmount(() => {
    stopTimerTicking()
  })

  const isActiveSlide = (movieId) => {
    return activeSlide.value.id === movieId
  }

  const setActiveSlide = () => {
    activeSlide.value = slides.value[currentIndex.value]
  }
  const playPauseTrailer = () => {
    if (playingState.value) {
      pauseTrailer()
    } else {
      playTrailer()
    }
  }

  const pauseTrailer = () => {
    heroYouTubePlayer.value.pauseVideo()
    playingState.value = false
  }

  const playTrailer = () => {
    heroYouTubePlayer.value.play()
    playingState.value = true
  }

  const muteTrailer = () => {
    if (heroYouTubePlayer.value) {
      heroYouTubePlayer.value.mute()
    }
  }

  const unMuteTrailer = () => {
    if (heroYouTubePlayer.value) {
      heroYouTubePlayer.value.unMute()
    }
  }


  const youtubeVideoStateChanged = async (ev) => {
    if (ev.data === 0) {
      nextSlide()
    }
  }
  const assignVideoPercent = (progress) => {
    videoPercent.value = progress
  }

  const pauseCurrentVideo = () => {
    if (heroYouTubePlayer.value) {
      heroYouTubePlayer.value.pauseVideo()
    }
  }

  return {
    startSlider,
    nextSlide,
    setSlides,
    getTimer,
    getCurrentImage,
    activeSlide,
    isActiveSlide,
    getSlides,
    currentIndex,
    setActiveSlide,
    duration,
    chooseSlide,
    heroYouTubePlayer,
    playPauseTrailer,
    pauseTrailer,
    playTrailer,
    playingControlBtn,
    youtubeVideoStateChanged,
    assignVideoPercent,
    thumbnailTimer,
    movieCurrentSlide,
    muteTrailer,
    unMuteTrailer
  }
}
